var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('LeftNavBar',{attrs:{"title":_vm.selectedAppInitial,"items":_vm.sidebarItems,"selectedValue":_vm.selectedNav},on:{"opened":_vm.selectFormType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }